import { HttpClient } from '@angular/common/http';
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { QueryBuilderService } from 'src/app/services/query-builder.service';


export interface Category {
  value: any;
  viewValue: string;
}

interface Categorys extends Array<Category> {}

export interface Sorting {
  value: any;
  viewValue: string;
}

export interface Operator {
  value: any;
  viewValue: string;
}

@Component({
  selector: 'app-text-search',
  templateUrl: './text-search.component.html',
  styleUrls: ['./text-search.component.scss']
})
export class TextSearchComponent implements OnInit {

  queryText: string;
  lang = "fr-FR";

  // Notiz keine Arrays in die Interfaces

    categoriesDE: Category[] = [
    { value: '_all', viewValue: 'Volltext' },
    { value: ['27_datum', '28_datum'], viewValue: 'Entstehungszeit' },
    { value: ['27_analyse_verfasserFA', '28_analyse_verfasserFA'], viewValue: 'Verfasser' },
    { value: ['27_analyse_empfaengerFA', '28_analyse_empfaengerFA'], viewValue: 'Empfänger' },
    { value: ['27_analyse_personenFA', '28_analyse_personenFA'], viewValue: 'Weitere Personen' },
    { value: ['27_analyse_schlagwoerter', '28_analyse_schlagwoerter'], viewValue: 'Schlagwörter' },
    { value: ['27_analyse_or_en_ab', '28_analyse_or_en_ab'], viewValue: 'Vorlage' },
  ];
  
    categoriesFR: Category[] = [
      { value: '_all', viewValue: 'Plein texte' },
      { value: ['27_datum', '28_datum'], viewValue: 'Date' },
      { value: ['27_analyse_verfasserFA', '28_analyse_verfasserFA'], viewValue: 'Auteur' },
      { value: ['27_analyse_empfaengerFA', '28_analyse_empfaengerFA'], viewValue: 'Destinataire' },
      { value: ['27_analyse_personenFA', '28_analyse_personenFA'], viewValue: 'Autres personnes' },
      { value: ['27_analyse_schlagwoerter', '28_analyse_schlagwoerter'], viewValue: 'Mots clés' },
      { value: ['27_analyse_or_en_ab', '28_analyse_or_en_ab'], viewValue: 'Modèle' },
    ];
  
  selectedCategory : string;

  sortingsDE: Sorting[] = [
    { value: 'relevance', viewValue: 'Relevanz' },
    { value: 'Entstehungszeit', viewValue: 'Entstehungszeit' },
  ];
  sortingsFR: Sorting[] = [
    { value: 'relevance', viewValue: 'Pertinence' },
    { value: 'Entstehungszeit', viewValue: 'Date' },
  ];
  selectedSorting : string;


  operatorsDE: Operator[] = [
    { value: 'phrase_prefix', viewValue: 'genau' },
    { value: 'and', viewValue: 'und' },
    { value: 'or', viewValue: 'oder' },
  ];

  operatorsFR: Operator[] = [
    { value: 'phrase_prefix', viewValue: 'précis' },
    { value: 'and', viewValue: 'et' },
    { value: 'or', viewValue: 'ou' },
  ];
  selectedOperator : string;

  @Input()
  count: number;

  // TODO: should be typed to the emit
  @Output()
  search: EventEmitter<any> = new EventEmitter<any>();

  constructor( 
    private queryBuilder: QueryBuilderService,
    public http: HttpService
    ) { }

  ngOnInit() {

    this.http.getLanguage().subscribe( res => {
      console.log(res);
      this.lang = res;
    });

  if(this.lang == "de-DE"){
    this.selectedCategory = this.categoriesDE[0].value;
    this.selectedOperator = this.operatorsDE[0].value;
    this.selectedSorting = this.sortingsDE[0].value;
  }
  else if(this.lang == "fr-FR"){
    this.selectedCategory = this.categoriesFR[0].value;
    this.selectedOperator = this.operatorsFR[0].value;
    this.selectedSorting = this.sortingsFR[0].value;
  }

  //  this.selectedCategory = ['79_analyse_aktuell', '79_analyse_kirchen'];

    if (this.queryBuilder.getCat() !== undefined) {
      this.selectedCategory = this.queryBuilder.getCat();
    }

    if (this.queryBuilder.getOpt() !== undefined) {
      this.selectedOperator = this.queryBuilder.getOpt();
    }

    if (this.queryBuilder.getSort() !== undefined) {
      this.selectedSorting = this.queryBuilder.getSort();
    }

    if (this.queryBuilder.getQuerytext() !== undefined) {
      this.queryText = this.queryBuilder.getQuerytext();
    }

  }

  onSelectCat(event) {
    this.queryBuilder.setCat(event.value);
  }

  onSelectOpt(event) {
    this.queryBuilder.setOpt(event.value);
  }

  onSelectSort(event) {
    this.queryBuilder.setSort(event.value);
  }

  onSearchChange(event) {
    // console.log(event);
    this.queryBuilder.setQuerytext(event);
  }


  // onSelectOper(event) {
  //   this.queryBuilder.setOper(event.value);
  // }


  submitSearch() {



    this.search.emit({
      queryText: this.queryText,
      category: this.selectedCategory,
      sorting: this.selectedSorting,
      operator: this.selectedOperator
    });

  }

}
